import React, { useContext, useEffect, useState } from "react";
import Card from "./Card";
import AuthContext from "../Context/auth/AuthContext";
const AppLink = ({ cardDetails, cardIndex }) => {
  const authContext = useContext(AuthContext);
  const { user, isAuthenticated } = authContext;
  const [appLink, setAppLink] = useState("");
  const [extAppLink, setExtAppLink] = useState("");
  const [isAppLink, setIsAppLink] = useState(false);
  const [isExtAppLink, setIsExtAppLink] = useState(false);

  const isUserAuthorized = () => {
    if (
      user &&
      cardDetails &&
      cardDetails.role_ids &&
      cardDetails.role_ids.length > 0
    )
      return cardDetails.role_ids.filter((item) => user.role_ids.includes(item))
        ?.length;
    else if (user) return true;
    else return false;
  };

  useEffect(() => {
    if (cardDetails?.appId === "3217810" || cardDetails?.appId === "3217960" || cardDetails?.appId === "4395474") {
      // setAppLink(cardDetails.prodSpecUrl);
      setAppLink(cardDetails.extAppUrl);
      setExtAppLink(cardDetails.extAppUrl);
      setIsAppLink(true);
      setIsExtAppLink(true);
    } else if (user && isAuthenticated && isUserAuthorized()) {
      if (cardDetails.auth_method === 2) {
        if (cardDetails.configuration.url) {
          setAppLink(cardDetails.configuration.url);
        } else {
          setAppLink(cardDetails.sso.acs_url);
        }
      } else {
        setAppLink(cardDetails.configuration.login_url);
      }
      setIsAppLink(true);
    } else {
      setIsAppLink(false);
      if (cardDetails.prodSpecUrl !== "") {
        setAppLink(cardDetails.prodSpecUrl);
      } else {
        setAppLink("");
      }
    }
  }, [user]);

  return (
    <>
      <Card
        cardDetails={cardDetails}
        user={user}
        appLink={isAppLink}
        appUrl={appLink}
        extAppLink={isExtAppLink}
        extAppUrl={extAppLink}
        cardIndex={cardIndex}
      />
    </>
  );
};

export default AppLink;
